import React, { useEffect, useState, useRef } from "react";
import { View, ScrollView, Text, ImageBackground, SafeAreaView, TouchableOpacity, Image, Linking, ActivityIndicator } from "react-native";
import { useNavigation } from "@react-navigation/native";
import MobileHeader from "../components/mHeader";
import Footer from "../components/footer";
import Header from "../components/header";
import i18n from "../components/i18n";
import CookieConsent from "../components/CookieConsent";
import NewMobileHeader from "../components/newMobileHeader";
import AsyncStorage from "../components/AsyncStorage";
import axios from "axios";
import { API_MIDDLEWARE, API_REGION } from "@env";
import { region } from "expo-localization";

const Passport = () => {
    const navigation = useNavigation();
    const [lang, setLang] = useState("en");
    const [isLoading, setIsLoading] = useState(false);
    const [task1, setTask1] = useState(false)
    const [task2, setTask2] = useState(false)
    const [task3, setTask3] = useState(false)
    const [task4, setTask4] = useState(false)
    const [taskComplete, setTaskComplete] = useState(false)
    const [redeemed, setRedeemed] = useState(false)
    const [congratOverlay, setCongratOverlay] = useState(false)
    const [memberCode, setMemberCode] = useState("");
    const [memberRegion, setMemberRegion] = useState("");
    const [member, setMember] = useState({})
    const [isLoggedIn, setIsLoggedIn] = useState(false)

    const mounted = useRef(false);

    useEffect(() => {
        mounted.current = true;

        AsyncStorage.getData("mCode").then((value) => {
            if (!value) {
                //navigation.push("Login");
                setTask1(true)
                setTask2(true)
                setTask3(true)
                setTask4(true)
            } else {
                setIsLoggedIn(true)
                let loginDetail = JSON.parse(value);
                console.log(loginDetail)
                setMemberCode(loginDetail.code);
                setMemberRegion(loginDetail.region);

                let data = {
                    code: loginDetail.code,
                    username: loginDetail.username,
                    region: loginDetail.region,
                };

                customerGet(data, (customer) => {
                    setMember(customer)
                })

                let data2 = {
                    code: loginDetail.code,
                    region: loginDetail.region
                }

                getPassport(data2, (res) => {
                    if (res.stamp["Fine Huaiyang"] == "Y") {
                        setTask3(true)
                    }

                    if (res.stamp["Fine Shanghainese"] == "Y") {
                        setTask4(true)
                    }

                    if (res.stamp["Fine Teochew Cuisine"] == "Y") {
                        setTask2(true)
                    }

                    if (res.stamp["Super Peking Duck"] == "Y") {
                        setTask1(true)
                    }

                    if (res.stamp["Fine Huaiyang"] == "Y" && res.stamp["Fine Shanghainese"] == "Y" && res.stamp["Fine Teochew Cuisine"] == "Y" && res.stamp["Super Peking Duck"] == "Y") {
                        setTaskComplete(true)
                    }

                    if (res.redeemed == "Y") {
                        setRedeemed(true)
                    }
                })
            }
        })

        AsyncStorage.getData("lang").then((lang) => {
            if (lang) {
                setLang(lang)
            }
        });

        return () => {
            mounted.current = false;
        };
    }, []);

    const getNow = () => {
        setIsLoading(true)
        
        let data = {
            code: memberCode,
            region: memberRegion
        }

        redeemPassport(data, (res) => {
            if (res.status == "success") {
                setCongratOverlay(true)
                setIsLoading(false)
            } else {
                alert(res.message)
                setIsLoading(false)
            }
        })
    }

    const getPassport = (data, callback) => {
        let formData = new FormData();
        formData.append("method", "getPassport");
        formData.set("region", data.region);
        formData.set("code", data.code);

        axios
        .post(API_MIDDLEWARE, formData)
        .then(function (response) {
            callback(response.data);
        })
        .catch(function (error) {
            callback(false);
        });
    }

    const redeemPassport = (data, callback) => {
        let formData = new FormData();
        formData.append("method", "redeemPassport");
        formData.set("region", data.region);
        formData.set("code", data.code);

        axios
        .post(API_MIDDLEWARE, formData)
        .then(function (response) {
            callback(response.data);
        })
        .catch(function (error) {
            callback(false);
        });
    }

    const customerGet = (data, callback) => {
        let formData = new FormData();
        formData.append("method", "getCust");
        formData.set("username", data.username);
        formData.set("region", data.region);
        formData.set("code", data.code);

        axios
        .post(API_MIDDLEWARE, formData)
        .then(function (response) {
            callback(response.data);
        })
        .catch(function (error) {
            callback(false);
        });
    };

    return (
        <View className="flex-1 md:bg-[#efefef] w-full" pointerEvents={!isLoading ? "auto" : "none"}>
            <ImageBackground source={require("../assets/login-bg.png")} resizeMode="cover" className="flex-1 justify-start items-center w-full h-full">
                {isLoading && (
                    <View
                        className="left-0 right-0 top-0 bottom-0 justify-center items-center bg-[#f3f3f394] z-10 w-full h-full"
                        style={{ position: "fixed" }}
                        pointerEvents={"none"}
                    >
                        <ActivityIndicator size="large" color={"#BD9B60"} />
                    </View>
                )}
                <SafeAreaView className="flex-1 bg-white flex justify-start items-center w-full md:bg-transparent">
                    <NewMobileHeader />
                    {/* <MobileHeader title={i18n.t("mobileApp.title")} /> */}
                    <ScrollView className="w-full flex-1">
                        <Header />
                        <View className="items-center content-start">
                            <View className="w-11/12 md:w-4/5 md:max-w-screen-sm md:h-auto md:m-auto md:bg-white md:p-7 mt-6 md:mb-24 pb-10 md:px-20">
                                {
                                    isLoggedIn &&
                                    <Text className="text-brandgold text-lg mb-6 uppercase font-Crimson text-center">{i18n.t("passport.welcome")}, {member.title} {member.last_name}!</Text>
                                }
                                {
                                    !isLoggedIn &&
                                    <Text className="text-brandgold text-lg mb-6 uppercase font-Crimson text-center">{i18n.t("passport.welcome")}!</Text>
                                }

                                <Text className="text-black text-2xl mb-1 uppercase font-Crimson text-center">{i18n.t("passport.intro1")}{"\n"}{i18n.t("passport.intro2")}</Text>

                                <Text className="text-[#84818A] text-sm mb-6 uppercase font-Crimson text-center">{i18n.t("passport.period")}</Text>
                                <ImageBackground source={require("../assets/campaign-star.png")} resizeMode="center" className="flex-1 justify-start items-center w-full h-full">
                                    <View className="flex flex-row flex-wrap justify-between">
                                        <View className={(task1 ? "bg-[#F5F0E7]" : "bg-[#F2F3F5]") + " w-[49%] rounded-[30px] flex items-center justify-center py-[10px] mb-[11px]"}>
                                            <View className={(task1 ? "bg-brandgold" : "bg-white") + " w-32 h-32 rounded-full flex items-center justify-center"}>
                                                <Image source={task1 ? require("../assets/passport/pass-3.png") : require("../assets/passport/pass-3-bw.png")} className="w-28 h-28" />
                                                {
                                                    task1 && <Image source={require("../assets/passport/tick.png")} className="absolute right-1.5 top-1.5 w-5 h-5" />
                                                }
                                            </View>
                                            <Text className={(task1 ? "text-brandgold" : "text-black") + " text-xs font-Crimson text-center mt-3"}>{i18n.t("passport.imp")}{"\n"}{i18n.t("passport.peking_duck")}</Text>
                                            <Text className={(task1 ? "text-brandgold" : "text-black") + " text-[10px] font-Crimson text-center"}>{i18n.t("passport.jewel_asiasquare")}</Text>
                                        </View>

                                        <View className={(task2 ? "bg-[#F5F0E7]" : "bg-[#F2F3F5]") + " w-[49%] rounded-[30px] flex items-center justify-center py-[10px] mb-[11px]"}>
                                            <View className={(task2 ? "bg-brandgold" : "bg-white") + " w-32 h-32 rounded-full flex items-center justify-center"}>
                                                <Image source={task2 ? require("../assets/passport/pass-4.png") : require("../assets/passport/pass-4-bw.png")} className="w-28 h-28" />
                                                {
                                                    task2 && <Image source={require("../assets/passport/tick.png")} className="absolute right-1.5 top-1.5 w-5 h-5" />
                                                }
                                            </View>
                                            <Text className={(task2 ? "text-brandgold" : "text-black") + " text-xs font-Crimson text-center mt-3"}>{i18n.t("passport.imp")}{"\n"}{i18n.t("passport.teochew_cuisine")}</Text>
                                            <Text className={(task2 ? "text-brandgold" : "text-black") + " text-[10px] font-Crimson text-center"}>{i18n.t("passport.ion_orchard_marina_bay_sands")}</Text>
                                        </View>

                                        <View className={(task3 ? "bg-[#F5F0E7]" : "bg-[#F2F3F5]") + " w-[49%] rounded-[30px] flex items-center justify-center py-[10px]"}>
                                            <View className={(task3 ? "bg-brandgold" : "bg-white") + " w-32 h-32 rounded-full flex items-center justify-center"}>
                                                <Image source={task3 ? require("../assets/passport/pass-1.png") : require("../assets/passport/pass-1-bw.png")} className="w-28 h-28" />
                                                {
                                                    task3 && <Image source={require("../assets/passport/tick.png")} className="absolute right-1.5 top-1.5 w-5 h-5" />
                                                }
                                            </View>
                                            <Text className={(task3 ? "text-brandgold" : "text-black") + " text-xs font-Crimson text-center mt-3"}>{i18n.t("passport.imp")}{"\n"}{i18n.t("passport.huaiyang_cuisine")}</Text>
                                            <Text className={(task3 ? "text-brandgold" : "text-black") + " text-[10px] font-Crimson text-center"}>{i18n.t("passport.ion_orchard")}</Text>
                                        </View>

                                        <View className={(task4 ? "bg-[#F5F0E7]" : "bg-[#F2F3F5]") + " w-[49%] rounded-[30px] flex items-center justify-center py-[10px]"}>
                                            <View className={(task4 ? "bg-brandgold" : "bg-white") + " w-32 h-32 rounded-full flex items-center justify-center"}>
                                                <Image source={task4 ? require("../assets/passport/pass-2.png") : require("../assets/passport/pass-2-bw.png")} className="w-28 h-28" />
                                                {
                                                    task4 && <Image source={require("../assets/passport/tick.png")} className="absolute right-1.5 top-1.5 w-5 h-5" />
                                                }
                                            </View>
                                            <Text className={(task4 ? "text-brandgold" : "text-black") + " text-xs font-Crimson text-center mt-3"}>{i18n.t("passport.imp")}{"\n"}{i18n.t("passport.shanghai_cuisine")}</Text>
                                            <Text className={(task4 ? "text-brandgold" : "text-black") + " text-[10px] font-Crimson text-center"}>{i18n.t("passport.takashimaya")}</Text>
                                        </View>
                                    </View>
                                </ImageBackground>


                                <Text className="text-black text-sm mt-4 mb-1.5 uppercase font-Crimson">{i18n.t("passport.tnc")}</Text>

                                <View className="mb-2 flex-row">
                                    <Text className="text-xs text-[#84818A] font-Crimson">1.</Text>
                                    <Text className="flex-1 pl-2 text-xs text-[#84818A] font-Crimson">
                                        {i18n.t("passport.tnc_1")}
                                    </Text>
                                </View>
                                <View className="mb-2 flex-row">
                                    <Text className="text-xs text-[#84818A] font-Crimson">2.</Text>
                                    <Text className="flex-1 pl-2 text-xs text-[#84818A] font-Crimson">
                                        {i18n.t("passport.tnc_2")}
                                    </Text>
                                </View>
                                <View className="mb-2 flex-row">
                                    <Text className="text-xs text-[#84818A] font-Crimson">3.</Text>
                                    <Text className="flex-1 pl-2 text-xs text-[#84818A] font-Crimson">
                                        {i18n.t("passport.tnc_3")}
                                    </Text>
                                </View>
                                <View className="mb-2 flex-row">
                                    <Text className="text-xs text-[#84818A] font-Crimson">4.</Text>
                                    <Text className="flex-1 pl-2 text-xs text-[#84818A] font-Crimson">
                                       {i18n.t("passport.tnc_4")}
                                    </Text>
                                </View>

                                {
                                    !isLoggedIn &&
                                    <TouchableOpacity className="w-full h-10 max-h-10 bg-brandgold mt-4" onPress={() => { navigation.push("SignUp") }}>
                                        <Text className="text-white w-full h-10 leading-10 text-center font-normal font-PingFangSC">{i18n.t("passport.register_now")}</Text>
                                    </TouchableOpacity>
                                }

                                {
                                    (!taskComplete && isLoggedIn && !redeemed) &&
                                    <View className="w-full h-10 max-h-10 bg-[#E5E5E5] mt-4">
                                        <Text className="text-white w-full h-10 leading-10 text-center font-normal font-PingFangSC">{i18n.t("passport.get_now")}</Text>
                                    </View>
                                }

                                {
                                    (taskComplete && isLoggedIn && !redeemed) &&
                                    <TouchableOpacity className="w-full h-10 max-h-10 bg-brandgold mt-4" onPress={() => { getNow() }}>
                                        <Text className="text-white w-full h-10 leading-10 text-center font-normal font-PingFangSC">{i18n.t("passport.get_now")}</Text>
                                    </TouchableOpacity>
                                }

                                {
                                    redeemed &&
                                    <View className="w-full h-10 max-h-10 bg-[#E5E5E5] mt-4">
                                        <Text className="text-white w-full h-10 leading-10 text-center font-normal font-PingFangSC">{i18n.t("passport.redeemed")}</Text>
                                    </View>
                                }


                                {/* <TouchableOpacity className="w-full h-10 max-h-10 bg-brandgold mt-4" onPress={() => { alert("hi") }}>
                                    <Text className="text-white w-full h-10 leading-10 text-center font-normal font-PingFangSC">GET NOW</Text>
                                </TouchableOpacity> */}
                            </View>
                        </View>



                        <Footer />
                        <CookieConsent />
                    </ScrollView>
                </SafeAreaView>
            </ImageBackground>

            {
                congratOverlay &&

                <View className="top-0 right-0 bottom-0 left-0 justify-center items-center bg-[#00000075]" style={{ position: "fixed" }}>
                    <View className="w-11/12 max-w-xs bg-white px-6 py-3 relative">
                        <TouchableOpacity
                            className="absolute right-1 top-1"
                            onPress={() => {
                                navigation.push('Coupon')
                            }}
                        >
                            <Image className="w-5 h-5" source={require("../assets/btn-close.png")} />
                        </TouchableOpacity>

                        <Text className="text-xl font-semibold text-brandgold text-center pt-11 uppercase font-Crimson">
                            {i18n.t("passport.congratulations")}
                        </Text>

                        <Text className="text-2xl font-semibold text-[#111111] text-center py-6 uppercase font-Crimson">
                            {i18n.t("passport.evouchers")}
                        </Text>

                        <Text className="text-xs text-[#84818A] text-center pb-3.5 font-Crimson">
                            {i18n.t("passport.successfully")}
                        </Text>

                        <View className="text-right flex items-end mb-8">
                            <TouchableOpacity
                                className="w-full h-8 max-h-8 bg-brandgold mt-4 mr-0"
                                onPress={() => { navigation.push('Coupon') }}
                            >
                                <Text className="text-white w-full h-8 leading-8 text-center font-normal font-PingFangSC uppercase">{i18n.t("passport.view_vouchers")}</Text>
                            </TouchableOpacity>
                        </View>
                    </View>
                </View>
            }
        </View>
    );
};

export default Passport;
